/**
 * Styled Components - Created by eduardoquintero on 19/10/20.
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'
import { CardOption, Cards } from '../../screens/DesignPaths/styledComponents'

export const LabelsTop = styled.div`
  margin-bottom: 16px;
  text-align: left;
  color: var(--neutral-darkest);
  font: 600 32px/38px var(--font-barlow-semi-condensed);
  #eyebrow {
    color: var(--neutral-secondary);
    font: 600 12px/20px Barlow;
    letter-spacing: 1.12px;
    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 30px;
  }
  @media (max-width: 698px) {
    padding: 0 6px;
    color: ${WHITE};
    #eyebrow {
      color: ${WHITE};
    }
  }
`

export const ModalCards = styled(Cards)`
  width: 100%;
  margin-top: 0;
  flex-wrap: wrap;
  justify-content: center;

  ${CardOption} {
    width: 422px;
    max-width: 422px;
    flex: 0 0 422px;
  }

  @media (max-width: 768px) {
    ${CardOption} {
      width: 100%;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
`

export const CloseBtn = styled.div`
  color: white;
  text-align: center;
  border: 1px solid white;
  padding: 6px;
  margin-block: 26px 18px;
  border-radius: 25px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StartDesignModal/styledComponents.tsx